import { useTranslation } from 'react-i18next';

export default function Conditions() {
  const { t } = useTranslation();

  return (
    <section className="py-12 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Título */}
        <div className="text-center mb-3">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">
            {t('conditions_delivery_title')}
          </h2>
          <p className="text-gray-500 text-sm sm:text-base">{t('conditions_delivery_subtitle')}</p>
        </div>
        <div className="w-20 h-0.5 bg-orange-500 mx-auto mb-10 sm:mb-14"></div>

        {/* Grid de 4 cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-8">
          {/* Previsão de Embarque */}
          <div className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-xl p-6 hover:shadow-md transition-shadow duration-200">
            <div className="flex items-center justify-center w-12 h-12 bg-orange-100 rounded-full mb-4 mx-auto">
              <i className="ri-ship-line text-2xl text-orange-500"></i>
            </div>
            <h3 className="text-base font-semibold text-gray-900 text-center mb-2">
              {t('conditions_shipping_title')}
            </h3>
            <p className="text-sm text-gray-600 text-center leading-relaxed">
              {t('conditions_shipping_desc')}
            </p>
          </div>

          {/* Entrega */}
          <div className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-xl p-6 hover:shadow-md transition-shadow duration-200">
            <div className="flex items-center justify-center w-12 h-12 bg-orange-100 rounded-full mb-4 mx-auto">
              <i className="ri-map-pin-line text-2xl text-orange-500"></i>
            </div>
            <h3 className="text-base font-semibold text-gray-900 text-center mb-2">
              {t('conditions_delivery_card_title')}
            </h3>
            <p className="text-sm text-gray-600 text-center leading-relaxed">
              {t('conditions_delivery_desc')}
            </p>
          </div>

          {/* Embalagem */}
          <div className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-xl p-6 hover:shadow-md transition-shadow duration-200">
            <div className="flex items-center justify-center w-12 h-12 bg-orange-100 rounded-full mb-4 mx-auto">
              <i className="ri-box-3-line text-2xl text-orange-500"></i>
            </div>
            <h3 className="text-base font-semibold text-gray-900 text-center mb-2">
              {t('conditions_packaging_title')}
            </h3>
            <p className="text-sm text-gray-600 text-center leading-relaxed">
              {t('conditions_packaging_desc')}
            </p>
          </div>

          {/* Garantia */}
          <div className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-xl p-6 hover:shadow-md transition-shadow duration-200">
            <div className="flex items-center justify-center w-12 h-12 bg-orange-100 rounded-full mb-4 mx-auto">
              <i className="ri-shield-check-line text-2xl text-orange-500"></i>
            </div>
            <h3 className="text-base font-semibold text-gray-900 text-center mb-2">
              {t('conditions_warranty_title')}
            </h3>
            <p className="text-sm text-gray-600 text-center leading-relaxed">
              {t('conditions_warranty_period')}
            </p>
          </div>
        </div>

        {/* Card Fabricante REMOVIDO */}
      </div>
    </section>
  );
}